import { render, staticRenderFns } from "./VehicleRequestStatistic.vue?vue&type=template&id=174830bd&"
import script from "./VehicleRequestStatistic.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports